import { BaseZenputCollection, Paginator, Project } from '../../../backbone-unorganized/shared/forms';

export const ActiveLocationRecurringFormProjects = BaseZenputCollection.extend({
    model: Project, // ParentProject
    paginator: null,
    typeahead_search_attrs: ['title'],
    search_param: 'search',

    url: function () {
        const location = $f.mobile.dashboard.get_active_account();
        const query_string = this.paginator.get_query_string({ attrs: ['start', 'limit', 'order_by', 'search'] });
        return `/api/v3/projects/parents_recurring_form/location/${location.id}/?${query_string}`;
    },

    initialize: function (models, options) {
        options = options || {};
        $.extend(this, options);

        if (!this.paginator) {
            this.paginator = new Paginator({ order_by: 'title' });
        }
    }
});
